module.exports = __webpack_public_path__ + "img/search.822c2c08.svg";